import type { JSX } from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { EDUCATION_LEVEL_LABELS } from '../types/education.types';
import type { EducationLevel } from '../types/education.types';

interface EducationLevelSelectProps {
  value: string;
  onChange: (v: string) => void;
  error?: string;
}

export function EducationLevelSelect({
  value,
  onChange,
  error,
}: EducationLevelSelectProps): JSX.Element {
  return (
    <div className="space-y-2">
      <Label htmlFor="educationLevel">
        Education Level <span className="text-destructive">*</span>
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select level" />
        </SelectTrigger>
        <SelectContent>
          {(Object.entries(EDUCATION_LEVEL_LABELS) as [EducationLevel, string][]).map(
            ([v, label]) => (
              <SelectItem key={v} value={v}>
                {label}
              </SelectItem>
            )
          )}
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
